import api from "../../api.js"

export const search = (query) => api.get("/frontshop/search", { params: { query } })
export const itemDetails = (sku) => api.get(`/frontshop/item/${sku}`)
export const warmCache = () => api.post("/frontshop/cache/warm")
export const clearCache = () => api.post("/frontshop/cache/clear")
export const cacheStatus = () => api.get("/frontshop/cache/status")
